export enum STATUS_MESSAGES {
  INITIAL = "Estamos verificando os documentos obrigatórios.",
  REDIRECT_TO_MANUAL_CAPTURE = "Redirecionando para a captura manual dos documentos pendentes.",
  STARTING_PROCESS = "Verificando disponibilidade da plataforma de captura.",
  REUSING_CAPTURE = "Encontramos uma captura anterior válida e vamos reaproveitá-la.",
  VALIDATING = "Capturando biometria e documento de identidade.",
  VERIFYING_RESULT = "Verificando o resultado da captura.",
  SAVE_INFORMATION = "Salvando informações do processo.",
  SAVE_DOCUMENT_DATA = "Salvando os documentos recuperados.",
  MANUAL_PENDING = "Falta enviar um ou mais documentos obrigatórios.",
  UNICO_UNAVAILABLE = "A plataforma de captura está indisponível no momento. Continue com o envio manual.",
  RESTART_REQUIRED = "Não foi possível reaproveitar a captura anterior. Será necessário reiniciar a captura.",
  UPDATING_PROPOSAL = "Atualizando a proposta com os dados validados.",
  SUCCESS = "Fluxo de captura concluído com sucesso.",
  ERROR = "Erro ao validar biometria. Tente novamente."
}

export const MAX_RETRY_ATTEMPTS = 1;